import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

// const MaterialList = Loadable(lazy(() => import("features/material/components/MaterialList")));
const MaterialPage = Loadable(
  lazy(
    () => import("features/material/components/Material/Material/MaterialPage")
  )
);
const MainPage = Loadable(
  lazy(() => import("features/material/components/MainPage"))
);

const routes = {
  path: "material",
  children: [
    // { path: "", element: <MaterialList /> },
    { path: "", element: <MainPage /> },
    { path: "add", element: <MaterialPage /> },
    { path: "edit/:materialId?", element: <MaterialPage /> },
  ],
};

export default routes;
